<template>
  <div class="video-item">
    <VideoTMG 
        :key="video.id"
        :video="video" 
        :nextVideo="nextVideo"
        />
    <div class="pt-5">
      <h3>
        {{ video.title }}
        <i v-if="seen" class="flaticon2-check-mark text-primary"></i>
      </h3>
      <p>{{ video.description }}</p>
    </div>
    <v-row  class="pt-10 pb-10 d-flex justify-content-center">
      <div class="d-flex flex-column justify-content-center">
        <p style="color:#3B3838; text-align: center; line-height:0.5em;">{{ $t('wish.noSatifyingVideo') }}</p>
        <FormWish mode="Video_NoSatifyingVideo" search="" searchResultNumber="" :video="String(this.video.id)" :theme="String(this.video.theme.id)" />
      </div>
    </v-row>
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import { userVideoSeen } from "@/core/utils/user";
import FormWish from "@/components/common/formWish";
import VideoTMG from "@/components/video/videoTMG";

export default {
  name: "contentVideo",
  components: {FormWish, VideoTMG},
  props: {
    video: Object,
    nextVideo: Object,
  },
  data: () => ({
    seen: false,
  }),
  computed: {
    ...mapGetters(["currentUser"]),
    apiUrl() {
      return process.env.VUE_APP_API;
    },
  },
  mounted() {
    this.seen = userVideoSeen(this.currentUser, this.video);
  },
};
</script>
